/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * ZEP QUIZ
 * Zep Quiz API
 * OpenAPI spec version: 0.0.1
 */

export type GetQuizsetRankingsPeriod = typeof GetQuizsetRankingsPeriod[keyof typeof GetQuizsetRankingsPeriod];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetQuizsetRankingsPeriod = {
  DAILY: 'DAILY',
  WEEKLY: 'WEEKLY',
  MONTHLY: 'MONTHLY',
} as const;
